import { render, staticRenderFns } from "./EventoDescripcion.vue?vue&type=template&id=14ba2278&scoped=true"
import script from "./EventoDescripcion.vue?vue&type=script&lang=js"
export * from "./EventoDescripcion.vue?vue&type=script&lang=js"
import style0 from "./EventoDescripcion.vue?vue&type=style&index=0&id=14ba2278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ba2278",
  null
  
)

export default component.exports